import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";

// Redirect users away from these routes if they are NOT logged in
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const context = useContext(AuthContext);
  return (
    <Route
      render={props =>
        context.isAuth ? <Component {...props} /> : <Redirect to="/login" />
      }
      {...rest}
    />
  );
};

export default ProtectedRoute;
